<template>
  <div>
    <el-select
      class="custom-select-beacon"
      v-model="beaconData"
      filterable
      multiple
      :popper-append-to-body="false"
      no-match-text="查無相關iBeacon"
      @visible-change="beaconSelectVisibleChange"
      :loading="beaconLoading"
      loading-text="載入中..."
      placeholder="請選擇iBeacon">
      <el-option
        v-for="item in beaconList"
        :key="item.beacon_id"
        :label="filterBeaconItemTitle(item)"
        :value="item.beacon_id">
      </el-option>
    </el-select>
    <div class="selector-buttons">
      <el-button plain v-loading.fullscreen.lock="loading" @click="handleSubmit">更新並儲存</el-button>
      <el-button plain @click="handleCloseEdit">取消</el-button>
    </div>
  </div>
</template>

<script>
  import { fetchBeaconList, updateBeacon } from "../../api/beacon";
  import { fetchBeaconMessage } from "../../api/beaconMessage";
  import { fetchCollection } from "../../api/collection";

  export default {
    name: "BeaconSelect",
    data() {
      return {
        beaconList: [],
        beaconData: [],
        originalBeaconData: [],
        loading: false,
        beaconLoading: false
      }
    },
    props: {
      bindingType: {
        type: String,
        require: true
      },
      bindingData: {
        type: Object,
        require: true
      }
    },
    filters: {
    },
    watch: {
      bindingData: {
        immediate: true,
        handler(newValue, oldValue) {
          if (newValue) {
            console.log(newValue);
            this.beaconData = [];
            for (const i in newValue['beacons']) {
              this.beaconData.push(newValue['beacons'][i]['beacon_id'])
            }
            this.originalBeaconData = JSON.parse(JSON.stringify(this.beaconData))
          } else {
            this.beaconData = [];
            this.originalBeaconData = [];
          }
        }
      },
    },
    mounted() {
      this.getBeacons()
    },
    methods: {
      filterBeaconItemTitle: function(beacon) {
        if (beacon['collection']) {
          return beacon['title'] + '\t\t\t' + beacon['collection']['collectionLangs'][0]['title']
        } else if (beacon['beaconMessage']) {
          return beacon['title'] + '\t\t\t' + beacon['beaconMessage']['title']
        } else {
          return beacon['title']
        }
      },
      beaconSelectVisibleChange(visible) {
        console.log('beaconSelectVisibleChange\t' + visible);
        if (visible) {
          this.getBeacons();
        }
      },
      getBeacons() {
        const filter = {
          where: {
            type: this.bindingType === 'collection' ? 0 : 1
          },
          order: ['title ASC']
        };
        this.beaconLoading = true;
        fetchBeaconList(filter).then(response => {
          this.getBeaconBindingData(response.data).then(beaconList => {
            this.beaconLoading = false;
            this.beaconList = beaconList;
            this.handleFilter();
          }).catch(bindingErr => {
            this.beaconLoading = false;
            this.beaconList = response.data;
          });
        }).catch(err => {
          this.beaconLoading = false;
        })
      },
      getBeaconBindingData: async function(beaconList) {
        try {
          for (const i in beaconList) {
            const beacon = beaconList[i];
            if (beacon['binding_type'] === 'collection' && beacon['object_id']) {
              const collectionData = await fetchCollection(beacon['object_id'], {
                include: [{
                  relation: 'collectionLangs',
                  scope: {
                    where: {
                      'language_key': 'ZH_TW'
                    }
                  }
                }]
              });
              beacon['collection'] = collectionData.data;
            } else if (beacon['binding_type'] === 'beaconMessage' && beacon['object_id']) {
              const messageData = await fetchBeaconMessage(beacon['object_id']);
              beacon['beaconMessage'] = messageData.data;
            }
          }
          return Promise.resolve(beaconList);
        } catch (e) {
          return Promise.reject(e);
        }
      },
      handleCloseEdit() {
        this.$emit('update', {
          reload: false
        })
      },
      handleSubmit() {
        this.loading = true;
        this.submitAsync().then(response => {
          this.loading = false;
          this.$emit('update', {
            reload: true
          })
        }).catch(err => {
          this.loading = false;
        })
      },
      submitAsync: async function () {
        try {
          console.log(this.bindingType);
          const promiseArray = [];
          for (const i in this.originalBeaconData) {
            const beaconId = this.originalBeaconData[i];
            if (this.beaconData.includes(beaconId) === false) {
              const request = updateBeacon(beaconId, {
                binding_type: null,
                object_id: null,
                is_binding: false
              });
              promiseArray.push(request)
            }
          }
          for (const i in this.beaconData) {
            let objectId = null;
            if (this.bindingType === 'collection') {
              objectId = this.bindingData['collection_id']
            } else if (this.bindingType === 'beaconMessage') {
              objectId = this.bindingData['beacon_message_id']
            } else if (this.bindingType === 'level') {
              objectId = this.bindingData['level_id']
            }
            const request = updateBeacon(this.beaconData[i], {
              binding_type: this.bindingType,
              object_id: objectId,
              is_binding: true
            });
            promiseArray.push(request)
          }
          await Promise.all(promiseArray);
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }
  }
</script>

<style lang="scss">
  .custom-select-beacon {
    width: 100%;
    .el-select__tags {
      .el-tag--info {
        border-color: #606266;
        color: #606266;
        background: white;
      }
    }
  }
  .selector-buttons {
    margin-top: 20px;
    text-align: center;
  }
</style>
